export const languages = [
  { name: "english", short: "eng" },
  { name: "srpski", short: "srb" },
];
